"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9895],{

/***/ 60581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ useWishlist; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./gql/queries/wishList.ts
var wishList = __webpack_require__(85288);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ./gql/fragments/wishList.ts
var fragments_wishList = __webpack_require__(46350);
;// CONCATENATED MODULE: ./gql/mutations/wishList.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddItemToWishList($input: AddItemToWishListInput!) {\n    addItemToWishList(input: $input) {\n      ...wishListFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateItemInWishList($input: UpdateItemInWishListInput!) {\n    updateItemInWishList(input: $input) {\n      ...wishListFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveItemFromWishList($input: RemoveItemFromWishListInput!) {\n    removeItemFromWishList(input: $input)\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ADD_ITEM_TO_WISHLIST_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject(), fragments_wishList/* WISHLIST_FRAGMENT */.j);
var UPDATE_ITEM_IN_WISHLIST_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject1(), fragments_wishList/* WISHLIST_FRAGMENT */.j);
var REMOVE_ITEM_FROM_WISHLIST_MUTATION = (0,urql_core/* gql */.Ps)(_templateObject2());

// EXTERNAL MODULE: ./utils/dynamicYield.ts
var dynamicYield = __webpack_require__(64907);
// EXTERNAL MODULE: ./hooks/useIsServer.ts
var useIsServer = __webpack_require__(64724);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useGA4Events.tsx
var useGA4Events = __webpack_require__(89113);
;// CONCATENATED MODULE: ./hooks/useWishlist.ts














var useWishlist = function(pause, shouldOpenMiniCart) {
    var auth = (0,useAuth/* useAuth */.aC)();
    var ref = (0,useSiteConfig/* useSiteConfig */.N)(), staticFeatures = ref.staticFeatures, currency = ref.currency;
    var isServer = (0,useIsServer/* useIsServer */.w)();
    var ref1 = (0,useGA4Events/* useGA4Events */.tL)(), imageType = ref1.imageType, imageNumber = ref1.imageNumber;
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useQuery */.aM)({
        query: wishList/* WISHLIST_QUERY */.z,
        pause: !!auth.guest || isServer || pause
    }), 1), wishlist = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(ADD_ITEM_TO_WISHLIST_MUTATION), 2), _ = ref3[0], addItemToWishList = ref3[1];
    var addItemToWishListCallback = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(variables) {
            var ref, _tmp, res, item, _quantity;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PDP_INTERACTION */._q.PDP_INTERACTION, (_tmp.domevent = "wishlist - add", _tmp.domlabel = "".concat(variables.input.productId, "_").concat(variables.input.swatch), _tmp));
                        return [
                            4,
                            addItemToWishList(variables)
                        ];
                    case 1:
                        res = _state.sent();
                        item = (ref = res.data) === null || ref === void 0 ? void 0 : ref.addItemToWishList.items.find(function(x) {
                            return x.product.masterId === variables.input.productId && x.product.colorValue === variables.input.swatch && x.product.size.value === variables.input.size;
                        });
                        if (item) {
                            if (shouldOpenMiniCart) {
                                openMiniCart(item);
                            }
                            ;
                            (0,analytics/* addToWishListEvent */.XO)(currency === null || currency === void 0 ? void 0 : currency.code, item, (_quantity = variables.input.quantity) !== null && _quantity !== void 0 ? _quantity : undefined, imageType, imageNumber);
                        }
                        if ((staticFeatures === null || staticFeatures === void 0 ? void 0 : staticFeatures.injectDynamicYieldScripts) && item) {
                            (0,dynamicYield/* dyAddToWishlistEvent */.A_)(item.product.styleNumber, item.product.size.label);
                        }
                        return [
                            2,
                            res
                        ];
                }
            });
        });
        return function addItemToWishListCallback(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(UPDATE_ITEM_IN_WISHLIST_MUTATION), 2), updateItemInWishList = ref4[1];
    var updateItemInWishListCallback = (0,react.useCallback)(function(variables) {
        return updateItemInWishList(variables, {
            additionalTypenames: [
                "WishList"
            ]
        });
    }, [
        updateItemInWishList
    ]);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,urql_es/* useMutation */.Db)(REMOVE_ITEM_FROM_WISHLIST_MUTATION), 2), removeItemFromWishList = ref5[1];
    var removeItemFromWishListCallback = (0,react.useCallback)(function(variables) {
        return removeItemFromWishList(variables, {
            additionalTypenames: [
                "WishList"
            ]
        });
    }, [
        removeItemFromWishList
    ]);
    return [
        wishlist,
        {
            add: addItemToWishListCallback,
            update: updateItemInWishListCallback,
            remove: removeItemFromWishListCallback
        }, 
    ];
};


/***/ }),

/***/ 33216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wishlist": function() { return /* binding */ Wishlist; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(60074);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(34209);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useCart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69771);
/* harmony import */ var hooks_useWishlist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60581);
/* harmony import */ var ui_components_withAuth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38849);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77480);
/* harmony import */ var ui_components_Page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87150);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37678);
/* harmony import */ var ui_components_EditProductModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6723);
/* harmony import */ var ui_elements_Link__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68302);
/* harmony import */ var ui_components_MiniCart__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65656);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83168);
/* harmony import */ var hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38859);
/* harmony import */ var ui_components_Img__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53579);
/* harmony import */ var utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69377);
/* harmony import */ var ui_components_AvailabilityBadge__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(34617);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(72507);
/* harmony import */ var ui_components_Price__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81406);
/* harmony import */ var utils_isNumber__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(95442);
/* harmony import */ var ui_components_PageHead__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9294);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(20368);
/* harmony import */ var utils_dateCalculations__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(35525);
/* harmony import */ var ui_components_RemoveWishlistItemModal__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(81985);
/* harmony import */ var ui_components_AddToCartButton__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(56202);
/* harmony import */ var hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(43308);

































var WishlistItem = function(param) {
    var item = param.item, add = param.add, update = param.update, remove = param.remove, _showImage = param.showImage, showImage = _showImage === void 0 ? true : _showImage;
    var ref, ref1, ref2;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__/* .useTranslate */ .qM)();
    var ref3 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_20__/* .useSiteConfig */ .N)(), locale = ref3.locale, showHeaderSubHeaderProductDetail = ref3.staticFeatures.showHeaderSubHeaderProductDetail;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), adding = ref4[0], setAdding = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), editing = ref5[0], setEditing = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), removing = ref6[0], setRemoving = ref6[1];
    var product = item.product, quantity = item.quantity, id = item.id, creationDate = item.creationDate;
    var openMiniCart = (0,hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_13__/* .useMiniCart */ .lm)().openMiniCart;
    var outOfStock = (product.inventory || 0) < quantity;
    var isSale = (0,utils_isNumber__WEBPACK_IMPORTED_MODULE_24__/* .isNumber */ .h)(product.salePrice) && product.salePrice !== product.price;
    var isPresale = !!(((ref = product.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.presale) && ((ref1 = product.displayOutOfStock) === null || ref1 === void 0 ? void 0 : ref1.validTo));
    var pageviewEventHasFired = (0,hooks_usePageEventsContext__WEBPACK_IMPORTED_MODULE_23__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    var productUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,utils_buildProductUrl__WEBPACK_IMPORTED_MODULE_15__/* .buildProductUrl */ .B)(product.masterId, product.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)({
            color: product.colorValue
        }, product.size.value && {
            size: product.size.value
        }));
    }, [
        product
    ]);
    var onAddToCart = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(function() {
            var res, _tmp, ref, items, _tmp1, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_27__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        if (!add) throw new Error("No add function found");
                        setAdding(true);
                        _tmp = {};
                        return [
                            4,
                            add((_tmp.productId = product.id, _tmp.quantity = quantity, _tmp.swatch = product.colorValue, _tmp.masterId = product.masterId, _tmp))
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.error) throw res.error;
                        _tmp1 = {};
                        if (res.data) {
                            ;
                            items = (ref = res.data.addItemsToCart.products) === null || ref === void 0 ? void 0 : ref.filter(function(p) {
                                return p.__typename === "ProductCartItem" && (p === null || p === void 0 ? void 0 : p.product.id) === product.id;
                            });
                            if (pageviewEventHasFired) {
                                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsEvents.GA4_CustomEvent */ ._q.GA4_CustomEvent, (_tmp1.event_name = utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsEvents.WISHLIST_TRANSFER */ ._q.WISHLIST_TRANSFER, _tmp1.event_params = {
                                    item_id_ep: product.id,
                                    item_name_ep: product.name
                                }, _tmp1));
                            }
                            if (items) openMiniCart(items);
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_28__/* .captureException */ .Tb(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setAdding(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onAddToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var canAddToCart = Boolean((product === null || product === void 0 ? void 0 : product.orderable) && (!product.displayOutOfStock || isPresale) && !outOfStock && !product.offline);
    var isSalePriceElapsed = product === null || product === void 0 ? void 0 : (ref2 = product.productPrice) === null || ref2 === void 0 ? void 0 : ref2.isSalePriceElapsed;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center flex-grow sm:flex-col",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "sm:flex font-display w-full relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center space-x-4 sm:space-x-8 md:space-x-12 flex-grow",
                            children: [
                                showImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_elements_Link__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                                    href: productUrl,
                                    dataTestId: "wishlist-item-image-link",
                                    className: "flex-none flex flex-col relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-32 xs:w-48 sm:w-52 md:w-64",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Img__WEBPACK_IMPORTED_MODULE_14__/* .Img */ .E, {
                                                src: product.images[0].href.replace(/1000/g, "600"),
                                                alt: product.images[0].alt,
                                                width: 300
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_AvailabilityBadge__WEBPACK_IMPORTED_MODULE_16__/* .AvailabilityBadge */ .T, {
                                            className: "hidden 2xs:flex absolute bottom-1 left-1",
                                            outOfStock: outOfStock,
                                            offline: item.product.offline
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex-grow pr-4",
                                    "data-test-id": "wishlist-item",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col w-full",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "font-bold text-puma-black text-sm xs:text-base sm:text-xl md:text-xl leading-tight",
                                                    children: showHeaderSubHeaderProductDetail ? product.header : product.name
                                                }),
                                                showHeaderSubHeaderProductDetail && product.subHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "w-full text-sm xs:text-base sm:text-xl md:text-xl text-puma-gray-60 line-clamp-2",
                                                    children: product.subHeader
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs sm:text-sm md:text-lg",
                                            "data-test-id": "color",
                                            children: product.colorName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "flex items-center space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-bold text-puma-black text-xs sm:text-sm uppercase",
                                                                children: [
                                                                    t("size"),
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-xs sm:text-sm",
                                                                "data-test-id": "size",
                                                                children: product.size.label
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "flex items-center space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-bold text-puma-black text-xs sm:text-sm uppercase",
                                                                children: [
                                                                    t("price"),
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: (0,twind__WEBPACK_IMPORTED_MODULE_29__.tw)("text-xs sm:text-sm whitespace-nowrap", isSale ? "opacity-50 line-through" : ""),
                                                                "data-test-id": "price",
                                                                children: (!isSale || !isSalePriceElapsed) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Price__WEBPACK_IMPORTED_MODULE_18__/* .Price */ .t, {
                                                                    amount: product.price
                                                                })
                                                            }),
                                                            isSale && (0,utils_isNumber__WEBPACK_IMPORTED_MODULE_24__/* .isNumber */ .h)(product.salePrice) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "text-xs sm:text-sm whitespace-nowrap font-bold text-puma-red mr-2",
                                                                "data-test-id": "sale-price",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_Price__WEBPACK_IMPORTED_MODULE_18__/* .Price */ .t, {
                                                                    amount: product.salePrice
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "flex items-center space-x-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: "font-bold text-puma-black text-xs sm:text-sm uppercase",
                                                                children: [
                                                                    t("styleNumber"),
                                                                    ":"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: (0,twind__WEBPACK_IMPORTED_MODULE_29__.tw)("text-xs sm:text-sm whitespace-nowrap"),
                                                                children: product.styleNumber
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mt-2 sm:mt-4 space-x-2",
                                            children: [
                                                update && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                    className: "border-b-0",
                                                    dataTestId: "edit-product-button",
                                                    disabled: removing || editing,
                                                    variant: "ghost",
                                                    label: "Edit ".concat(product.name),
                                                    onClick: function() {
                                                        return setEditing(true);
                                                    },
                                                    icon: "pencil",
                                                    mode: "icon"
                                                }),
                                                remove && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                    className: "border-b-0",
                                                    dataTestId: "remove-product-button",
                                                    disabled: removing || editing,
                                                    label: t("removeProduct", {
                                                        product: product.name
                                                    }),
                                                    variant: "ghost",
                                                    onClick: function() {
                                                        setRemoving(true);
                                                    },
                                                    icon: "trash",
                                                    mode: "icon"
                                                })
                                            ]
                                        }),
                                        add && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "hidden sm:flex",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_AddToCartButton__WEBPACK_IMPORTED_MODULE_22__/* .AddToCartButton */ .a, {
                                                className: "mt-4 w-full mobile:hidden",
                                                disabled: !canAddToCart,
                                                isAppExclusive: product.isAppExclusive,
                                                loading: adding,
                                                onAddToCart: onAddToCart,
                                                outOfStock: outOfStock,
                                                presale: isPresale,
                                                appOnlyDateTimeFrom: product.appOnlyDateTimeFrom,
                                                appOnlyDateTimeTo: product.appOnlyDateTimeTo
                                            })
                                        }),
                                        creationDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-end font-bold",
                                            "data-test-id": "wishList-item-date",
                                            children: [
                                                t("itemAdded"),
                                                " ",
                                                (0,utils_dateCalculations__WEBPACK_IMPORTED_MODULE_30__/* .longDateFormat */ .ZR)(creationDate, locale)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        add && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "sm:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_AddToCartButton__WEBPACK_IMPORTED_MODULE_22__/* .AddToCartButton */ .a, {
                                className: "mt-4 w-full",
                                disabled: !canAddToCart,
                                isAppExclusive: product.isAppExclusive,
                                loading: adding,
                                onAddToCart: onAddToCart,
                                outOfStock: outOfStock,
                                presale: isPresale,
                                appOnlyDateTimeFrom: product.appOnlyDateTimeFrom,
                                appOnlyDateTimeTo: product.appOnlyDateTimeTo
                            })
                        })
                    ]
                })
            }, product.id),
            update && editing && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_EditProductModal__WEBPACK_IMPORTED_MODULE_9__/* .EditProductModal */ .V, {
                id: item.id,
                price: product.salePrice || product.price,
                masterId: product.masterId,
                size: product.size.value,
                color: product.colorValue,
                onClose: function() {
                    return setEditing(false);
                },
                update: function(param) {
                    var size = param.size, swatch = param.swatch;
                    return update({
                        input: {
                            itemId: id,
                            productId: product.masterId,
                            quantity: quantity,
                            swatch: swatch,
                            size: size
                        }
                    });
                }
            }, product.masterId),
            removing && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_RemoveWishlistItemModal__WEBPACK_IMPORTED_MODULE_21__/* .RemoveWishlistItemModal */ .v, {
                onClickOutside: function() {
                    return setRemoving(false);
                },
                onConfirm: function() {
                    if (remove) {
                        remove({
                            input: {
                                itemId: id
                            }
                        });
                        setRemoving(false);
                    }
                },
                product: product
            })
        ]
    });
};
var Wishlist = function(param) {
    var t = param.t, wishList = param.wishList, update = param.update, remove = param.remove;
    var ref, ref1, ref2;
    var addToCart = (0,hooks_useCart__WEBPACK_IMPORTED_MODULE_3__/* .useCart */ .j)({
        pause: true
    }).addToCart;
    var ref3 = (0,hooks_useMiniCart__WEBPACK_IMPORTED_MODULE_13__/* .useMiniCart */ .lm)(), isMiniCartVisible = ref3.isMiniCartVisible, closeMiniCart = ref3.closeMiniCart;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return closeMiniCart;
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "max-w-screen-lg mx-auto xs:border xs:p-8 xs:rounded-xl w-full",
                "aria-label": t("myWishlist"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "border-b pb-5 flex items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "uppercase text-xl sm:text-2xl",
                                "data-test-id": "wishlist-header",
                                children: t("myWishlist")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "ml-auto text-sm sm:text-base md:text-lg lg:text-xl",
                                "data-test-id": "wishlist-item-count",
                                children: [
                                    (ref = wishList.data) === null || ref === void 0 ? void 0 : ref.wishList.items.length,
                                    " ",
                                    t("items")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "wishlist-products",
                        className: "w-full mx-auto divide-y",
                        children: ((ref1 = wishList.data) === null || ref1 === void 0 ? void 0 : ref1.wishList.items.length) === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "no-wishlist-items",
                            className: "flex flex-col w-full items-center justify-center font-display py-32 text-puma-black-500",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                    name: "heart"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-puma-black text-center text-3xl font-bold -mt-4 whitespace-pre-wrap",
                                    children: t("yourWishlistIsEmpty")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            children: (ref2 = wishList.data) === null || ref2 === void 0 ? void 0 : ref2.wishList.items.map(function(wishlistItem) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "flex items-start py-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistItem, {
                                        item: wishlistItem,
                                        remove: remove,
                                        update: update,
                                        add: function() {
                                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(function(variables) {
                                                var now, _tmp, res, _tmp1, _tmp2;
                                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_27__.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            now = new Date();
                                                            _tmp = {};
                                                            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsEvents.PDP_INTERACTION */ ._q.PDP_INTERACTION, (_tmp.domevent = "wishlist - transfer", _tmp.domlabel = "".concat(variables.productId, "_").concat(variables.swatch), _tmp.time = "".concat(now.getDate(), "-").concat(now.getMonth(), "-").concat(now.getFullYear()), _tmp));
                                                            _tmp1 = {};
                                                            _tmp2 = {};
                                                            return [
                                                                4,
                                                                addToCart([
                                                                    (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)(_tmp1, variables), (_tmp2.size = wishlistItem.product.size.value, _tmp2))
                                                                ])
                                                            ];
                                                        case 1:
                                                            res = _state.sent();
                                                            return [
                                                                2,
                                                                res
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(variables) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }()
                                    }, wishlistItem.id)
                                }, wishlistItem.id);
                            })
                        })
                    })
                ]
            }),
            isMiniCartVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_MiniCart__WEBPACK_IMPORTED_MODULE_11__/* .MiniCart */ .pp, {})
        ]
    });
};
var WishListPage = function() {
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_6__/* .useTranslate */ .qM)();
    var auth = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_17__/* .useAuth */ .aC)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .useMeQuery */ .UEB)({
        pause: auth.guest
    }), 1), meResult = ref[0];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)((0,hooks_useWishlist__WEBPACK_IMPORTED_MODULE_4__/* .useWishlist */ .E)(), 2), wishList = ref1[0], ref2 = ref1[1], update = ref2.update, remove = ref2.remove;
    var ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Page__WEBPACK_IMPORTED_MODULE_7__/* .Page */ .T, {
        query: [
            wishList,
            meResult
        ],
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_PageHead__WEBPACK_IMPORTED_MODULE_19__/* .PageHead */ .y, {
                title: t("pageTitle", {
                    title: (ref3 = t("pageTitleFragmentWishlist")) !== null && ref3 !== void 0 ? ref3 : t("wishlist")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wishlist, {
                t: t,
                wishList: wishList,
                update: update,
                remove: remove
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,ui_components_withAuth__WEBPACK_IMPORTED_MODULE_5__/* .withAuth */ .Q)(WishListPage, {
    redirectTo: "account/login",
    from: "wishlist"
}));


/***/ }),

/***/ 34617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ AvailabilityBadge; },
/* harmony export */   "v": function() { return /* binding */ STOCK_MESSAGE_CODE; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53625);





var STOCK_MESSAGE_CODE;
(function(STOCK_MESSAGE_CODE) {
    STOCK_MESSAGE_CODE["IN_STOCK"] = "IN_STOCK";
    STOCK_MESSAGE_CODE["LIMITED_STOCK"] = "LIMITED_STOCK";
    STOCK_MESSAGE_CODE["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(STOCK_MESSAGE_CODE || (STOCK_MESSAGE_CODE = {}));
var AvailabilityBadge = function(param) {
    var className = param.className, outOfStock = param.outOfStock, offline = param.offline, stockMessage = param.stockMessage, stockStatus = param.stockStatus;
    var shouldUseStockMessageFromResponse = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__/* .useFeature */ .S)("USE_STOCK_MESSAGE_FROM_RESPONSE");
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var isOutOfStock = outOfStock || shouldUseStockMessageFromResponse && stockStatus === "NOT_AVAILABLE";
    var isLimitedStock = shouldUseStockMessageFromResponse && stockStatus === "LIMITED_STOCK";
    var hasStockMessage = shouldUseStockMessageFromResponse && stockMessage ? true : false;
    var getBadgeLabel = function() {
        switch(true){
            case hasStockMessage:
                return stockMessage;
            case isOutOfStock:
                return t("outOfStock");
            case offline:
                return t("noLongerAvailable");
            case isLimitedStock:
                return t("inStock");
            default:
                return t("inStock");
        }
    };
    var getBadgeColor = function() {
        switch(true){
            case isOutOfStock:
                return "brand";
            case offline:
                return "muted";
            case isLimitedStock:
                return "warning";
            default:
                return "success";
        }
    };
    var getBadgeIcon = function() {
        switch(true){
            case isOutOfStock:
                return "close-filled";
            case offline:
                return "close-filled";
            case isLimitedStock:
                return "exclamation-filled";
            default:
                return "check-filled";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Badge */ .Cts, {
        className: className,
        "data-test-id": "stock-availability",
        outline: true,
        round: true,
        size: "sm",
        icon: getBadgeIcon(),
        color: getBadgeColor(),
        label: getBadgeLabel()
    });
};


/***/ }),

/***/ 57965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ ConfirmModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70868);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51377);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6485);







var ConfirmModal = function(param) {
    var onClickOutside = param.onClickOutside, children = param.children, onConfirm = param.onConfirm, dataTestId = param.dataTestId, loading = param.loading, confirmText = param.confirmText, cancelText = param.cancelText, reverseButtonOrder = param.reverseButtonOrder;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var confirmButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
            id: "confirm-button",
            dataTestId: "confirm-button",
            loading: loading,
            label: confirmText !== null && confirmText !== void 0 ? confirmText : t("confirmButtonModal"),
            className: "flex-grow h-[2.5rem]",
            onClick: onConfirm,
            children: confirmText !== null && confirmText !== void 0 ? confirmText : t("confirmButtonModal")
        });
    };
    var cancelButton = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
            id: "cancel-button",
            dataTestId: "cancel-button",
            label: cancelText !== null && cancelText !== void 0 ? cancelText : t("cancelButtonModal"),
            variant: reverseButtonOrder ? "secondary" : "primary",
            className: "flex-grow",
            onClick: onClickOutside
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClickOutside: onClickOutside,
        variant: "dark",
        className: "max-w-lg p-6",
        dataTestId: dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "absolute top-5 right-5 !mt-0",
                onClick: onClickOutside
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-6",
                children: [
                    children,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex space-x-4 w-full",
                        children: reverseButtonOrder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                cancelButton(),
                                confirmButton()
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                confirmButton(),
                                cancelButton()
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 6723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ EditProductModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70868);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var ui_components_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51377);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37678);
/* harmony import */ var utils_extractError__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4360);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53625);
/* harmony import */ var utils_products__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1032);
/* harmony import */ var _Sizes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38913);
/* harmony import */ var _Styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87260);
/* harmony import */ var _Price__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81406);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6485);

















var EditProductModal = function(props) {
    var ref, ref1;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.color), selectedColor = ref2[0], setSelectedColor = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.size), selectedSize = ref3[0], setSelectedSize = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSameProduct = ref4[0], setIsSameProduct = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), updating = ref5[0], setUpdating = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), error = ref6[0], setError = ref6[1];
    var showPriceDifference = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_7__/* .useFeature */ .S)("SHOW_PRICE_DIFFERENCE");
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useProductQuery */ .FA3)({
        variables: {
            id: props.masterId
        },
        pause: !props.masterId
    }), 1), product = ref7[0];
    var masterProduct = (ref = product.data) === null || ref === void 0 ? void 0 : ref.product;
    var chosenVariant = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(x) {
        return x.colorValue === selectedColor;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!chosenVariant) return;
        setIsSameProduct(chosenVariant.colorValue === props.color);
    }, [
        chosenVariant,
        props.color
    ]);
    if (!chosenVariant || !masterProduct) {
        return null;
    }
    var sizes = (0,utils_products__WEBPACK_IMPORTED_MODULE_8__/* .getSizesFromSizeGroups */ .hJ)(chosenVariant.sizeGroups);
    var selectedSizeIsOrderable = (ref1 = sizes.find(function(x) {
        return x.id === selectedSize;
    })) === null || ref1 === void 0 ? void 0 : ref1.orderable;
    var priceDifference = (chosenVariant.salePrice || chosenVariant.price) - props.price;
    var productVariations = (masterProduct.variations || []).filter(function(x) {
        var ref;
        return !((ref = x.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.comingsoon);
    });
    var styleNumberPrefix = t("styleNumberModalCart");
    var colorPrefix = t("colorModalCart");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_components_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClickOutside: props.onClose,
        variant: "dark",
        className: "w-full max-w-md p-8 sm:p-10 m-auto",
        dataTestId: "edit-product-modal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                className: "absolute top-5 right-5 !mt-0",
                onClick: props.onClose
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-4 sm:space-y-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            styleNumberPrefix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-puma-black-300",
                                        children: styleNumberPrefix
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "text-puma-black",
                                        children: [
                                            props.masterId,
                                            "_",
                                            selectedColor
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "text-puma-black-300",
                                children: [
                                    "#",
                                    props.masterId,
                                    "_",
                                    selectedColor
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-xl md:text-3xl font-bold leading-tight",
                                children: masterProduct.name
                            }),
                            colorPrefix ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-puma-black-300",
                                        children: colorPrefix
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-puma-black",
                                        children: chosenVariant.colorName
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-puma-black",
                                children: chosenVariant.colorName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Styles__WEBPACK_IMPORTED_MODULE_10__/* .Styles */ .z, {
                        desiredSwatch: selectedColor,
                        variations: productVariations,
                        onChange: function(swatch) {
                            setUpdating(false);
                            setError(undefined);
                            setSelectedColor(swatch);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Sizes__WEBPACK_IMPORTED_MODULE_9__/* .Sizes */ .u8, {
                        sizeGroups: chosenVariant.sizeGroups,
                        desiredSize: selectedSize,
                        onChange: function(newSize) {
                            setUpdating(false);
                            setError(undefined);
                            setSelectedSize(newSize);
                        }
                    }),
                    error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded mb-2 -mt-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: error
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "exclamation-outline",
                                size: "base"
                            })
                        ]
                    }),
                    !selectedSizeIsOrderable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded mb-2 -mt-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("selectedSizeIsNotOrderable")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
                                name: "exclamation-outline",
                                size: "base"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        label: t("updateItem"),
                        id: "save-product",
                        height: "tall",
                        className: "w-full",
                        loading: updating,
                        disabled: updating || !selectedSizeIsOrderable,
                        onClick: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                            var result, _tmp;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setUpdating(true);
                                        _tmp = {};
                                        return [
                                            4,
                                            props.update((_tmp.size = selectedSize, _tmp.swatch = selectedColor, _tmp))
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        if (result.error) {
                                            setError((0,utils_extractError__WEBPACK_IMPORTED_MODULE_16__/* .extractError */ .d)(result));
                                            setUpdating(false);
                                        } else {
                                            props.onClose();
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        children: [
                            t("updateItem"),
                            showPriceDifference && !isSameProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceDifference, {
                                difference: priceDifference
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var PriceDifference = function(props) {
    if (!props.difference) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            " (",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Price__WEBPACK_IMPORTED_MODULE_11__/* .Price */ .t, {
                amount: props.difference,
                showSign: true
            }),
            ")"
        ]
    });
};


/***/ }),

/***/ 81985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ RemoveWishlistItemModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);
/* harmony import */ var _ConfirmModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57965);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53579);




var RemoveWishlistItemModal = function(props) {
    var onClickOutside = props.onClickOutside, onConfirm = props.onConfirm, product = props.product;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ConfirmModal__WEBPACK_IMPORTED_MODULE_2__/* .ConfirmModal */ .s, {
        onClickOutside: onClickOutside,
        onConfirm: onConfirm,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "text-xl pr-8",
                children: t("removeWishlistItemConfirmation")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center border p-4 space-x-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-40",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_3__/* .Img */ .E, {
                            src: product.images[0].href.replace(/1000/g, "300"),
                            alt: product.images[0].alt,
                            width: 160
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-xs sm:text-sm md:text-base text-puma-black-300 pb-2",
                                        children: [
                                            "#",
                                            product.styleNumber
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "font-bold text-puma-black text-sm sm:text-lg md:text-xl leading-xxs",
                                        children: product.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-xs sm:text-sm !leading-[1em]",
                                        children: product.colorName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center space-x-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-bold text-puma-black text-xs sm:text-sm uppercase",
                                        children: [
                                            t("size"),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-xs sm:text-sm",
                                        children: product.size.label
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 38849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withAuth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72507);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20368);
/* harmony import */ var ui_components_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91622);







var withAuth = function(Component, options) {
    var WithUnauthenticatedRedirect = function(props) {
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
        var auth = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
        var localizeUrlPath = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_4__/* .useSiteConfig */ .N)().localizeUrlPath;
        var ref;
        var query = (ref = router.asPath.split("?")[1]) !== null && ref !== void 0 ? ref : "";
        (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
            if (auth.guest) {
                router.replace(localizeUrlPath("/account/login".concat(query ? "?".concat(query) : "").concat(query && (options === null || options === void 0 ? void 0 : options.from) ? "&from=".concat(encodeURIComponent(options.from)) : (options === null || options === void 0 ? void 0 : options.from) ? "?from=".concat(encodeURIComponent(options.from)) : "")));
            }
        });
        return auth.guest === false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "w-full py-48 xl:py-64",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_LoadingSpinner__WEBPACK_IMPORTED_MODULE_5__/* .LoadingSpinner */ .T, {
                className: "m-auto flex-none w-32 h-32"
            })
        });
    };
    return WithUnauthenticatedRedirect;
};


/***/ }),

/***/ 13583:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);